import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <Container className="my-5" style={{maxWidth: '800px'}}>
      <h1>Privacy Statement</h1>
      <h4>Introduction</h4>
      <p>
        QuickyChat is an AI platform designed to assist businesses in
        automating various processes, enhancing user engagement, and
        providing seamless AI integration solutions.
      </p>
      <p>
        We understand the importance of privacy and data protection, and we are
        committed to handling your personal information responsibly. This
        Privacy Notice outlines QuickyChat's policies and practices regarding
        the collection, use, and security of your personal data, as well as
        your privacy rights. We recognize that privacy is an evolving concern,
        and we may update this policy periodically to reflect changes in our
        practices.
      </p>

      <h4>Contacting Us About Data Protection</h4>
      <p>
        QuickyChat is an online business headquartered in the United States. If
        you have any questions or concerns regarding our data protection
        policies, or if you wish to exercise your privacy rights, you can reach
        out to our dedicated team at <Link to={'mailto:info@quickychat.com'} className="text-white">info@quickychat.com</Link>.
      </p>

      <h4>How We Collect and Use Your Personal Information</h4>
      <p>QuickyChat collects personal information from website visitors and customers. This information typically includes:</p>
      <ul>
        <li>Name</li>
        <li>Job title</li>
        <li>Company name</li>
        <li>Business address</li>
        <li>Email</li>
        <li>Phone number</li>
      </ul>
      <p>
        We collect this information to provide and improve our services,
        communicate with customers, and deliver personalized experiences.
        QuickyChat does not sell personal data.
      </p>

      <h4>Use of the QuickyChat Website</h4>
      <p>
        Like most websites, QuickyChat collects certain technical data
        automatically and stores it in log files. This may include:
      </p>
      <ul>
        <li>IP addresses</li>
        <li>Geographic location of access</li>
        <li>Browser type and operating system</li>
        <li>Website activity and browsing behavior</li>
      </ul>
      <p>
        We use this data to optimize website performance, diagnose technical
        issues, analyze trends, and enhance user experience. QuickyChat has a
        legitimate interest in understanding how users interact with our website
        to improve our services.
      </p>

      <h4>Cookies and Tracking Technologies</h4>
      <p>
        QuickyChat uses cookies and tracking technologies to enhance user
        experience. Users can manage cookie preferences through their browser
        settings.
      </p>

      <h4>Sharing Information with Third Parties</h4>
      <p>
        Personal data collected by QuickyChat is stored in databases managed by
        trusted third-party cloud providers. These providers do not use or
        access personal data beyond storage and retrieval services. In specific
        cases, we may share data with:
      </p>
      <ul>
        <li>Vendors and service providers assisting with our operations</li>
        <li>Authorities if required by law (e.g., compliance with legal processes)</li>
        <li>Business partners in cases of mergers or acquisitions</li>
      </ul>
      <p>
        We do not disclose personal data to third parties for independent
        marketing or sales purposes.
      </p>

      <h4>International Data Transfers</h4>
      <p>
        Your personal data may be processed in the United States. By using
        QuickyChat, you acknowledge that your data may be transferred
        internationally.
      </p>

      <h4>Your Privacy Rights</h4>
      <p>
        Depending on your location, you may have certain rights under privacy
        laws such as the GDPR or CCPA, including:
      </p>
      <ul>
        <li>Right to be informed about data collection</li>
        <li>Right to access your personal data</li>
        <li>Right to correct inaccurate data</li>
        <li>Right to request deletion of your data</li>
        <li>Right to restrict or object to processing</li>
        <li>Right to data portability</li>
      </ul>
      <p>
        To exercise your rights, contact us at <Link to={'mailto:info@quickychat.com'} className="text-white">info@quickychat.com</Link>.
      </p>

      <h4>Data Protection and Security Measures</h4>
      <p>To ensure the security of your data, QuickyChat implements the following measures:</p>
      <ul>
        <li>Encryption: Data is encrypted at rest and in transit.</li>
        <li>Access Control: User permissions limit access to sensitive data.</li>
        <li>Rate Limiting: Prevents misuse and spam interactions.</li>
        <li>Infrastructure Security: Hosted on secure cloud providers such as AWS.</li>
        <li>No AI Training: User data is not used for AI model training.</li>
      </ul>

      <h4>Data Storage and Retention</h4>
      <p>
        QuickyChat retains user data for the duration of the customer
        relationship and for a reasonable period afterward for legal, security,
        and operational purposes. Users can request data deletion by contacting
        <Link to={'mailto:info@quickychat.com'} className="text-white">info@quickychat.com</Link>.
      </p>

      <h4>Children’s Data</h4>
      <p>
        QuickyChat does not knowingly collect data from individuals under the
        age of 16.
      </p>

      <h4>Questions, Concerns, or Complaints</h4>
      <p>
        If you have any concerns or wish to exercise your rights, please
        contact us at <Link to={'mailto:info@quickychat.com'} className="text-white">info@quickychat.com</Link>.
      </p>

      <p>
        This Privacy Policy is subject to updates. We encourage users to review
        this policy periodically to stay informed about our data practices.
      </p>
      <p><strong>Effective Date: Jan 01, 2025</strong></p>
    </Container>
  );
};

export default PrivacyPolicy;
